import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import './Admission.css';
import axios from 'axios';
import toast from 'react-hot-toast';
import HeadingContainer from '../../heading-container/HeadingContainer';
import { LinearProgress, Alert, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

function Admission() {
    const [config, setConfig] = useState({
        studentName: "",
        parentName: "",
        dob: "2001-01-01",
        previousSchool: "",
        admissionForClass: "",
        parentOccupation: "",
        phone: "",
        email: ""
    });

    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [typeMessage, setTypeMessage] = useState('success'); 
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    const [visible, setVisible] = useState(false);
    const submitAdmission = async (e) => {
        e.preventDefault();
        if (config.studentName === "" || config.parentName === "" || config.dob === "" || config.previousSchool === "" || config.admissionForClass === "" || config.parentOccupation === "" || config.phone === "" || config.email === "") {
            toast.error('Please Fill All The Fields');
            setTypeMessage('error');
            setMessage('Please Fill All The Fields');
            setOpen(true);
            return;
        }

        setVisible(true);
        const backendUrl = process.env.REACT_APP_BACKEND_BASE_URI || "http://localhost:4000";
        try {
            await axios.post(`${backendUrl}/admission/api/addAdmission`, config, {
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_API_PASSWORD}`,
                    "Content-Type": "application/json",
                }
            });
            setVisible(false);
            setTypeMessage('success');
            setMessage('Admission Submitted Successfully');
            setOpen(true);
            toast.success('Admission Submitted Successfully');
            setConfig({
                studentName: "", parentName: "", dob: "2001-01-01", previousSchool: "", 
                admissionForClass: "", parentOccupation: "", phone: "", email: ""
            });
        } catch (err) {
            setTypeMessage('error');
            setMessage('Admission Submission Failed');
            setVisible(false);
            setOpen(true);
            toast.error('Admission Submission Failed');
            console.log(err);
        }
    }

    return (
        <>
            <HeadingContainer title="Admissions" />
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={typeMessage} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
            {visible && <LinearProgress color="success" />}

            <div className="admission-wrapper">
                <Container maxWidth="md" style={{ position: 'relative', zIndex: 10 }}>
                    <Box className="admission-card hover-scale">
                        <Typography variant="h4" className="text-center" sx={{ color: 'var(--primary)', fontWeight: 800, mb: 1, fontFamily: 'var(--font-heading)' }}>
                            Welcome to White Wings! 🎒
                        </Typography>
                        <Typography variant="subtitle1" className="text-center" sx={{ color: 'var(--text-muted)', mb: 4 }}>
                            Admission Open For Session 2025-2026. Fill out the application form below.
                        </Typography>
                        
                        <form onSubmit={submitAdmission}>
                            <Grid container spacing={4} className="text-center">
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Student's Name" value={config.studentName} onChange={(e) => setConfig({ ...config, studentName: e.target.value })} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Parent's Name" value={config.parentName} onChange={(e) => setConfig({ ...config, parentName: e.target.value })} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Date of Birth" type="date" value={config.dob} onChange={(e) => setConfig({ ...config, dob: e.target.value })} fullWidth required InputLabelProps={{ shrink: true }} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Previous School" value={config.previousSchool} onChange={(e) => setConfig({ ...config, previousSchool: e.target.value })} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Admission For Class" value={config.admissionForClass} onChange={(e) => setConfig({ ...config, admissionForClass: e.target.value })} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Parent's Occupation" value={config.parentOccupation} onChange={(e) => setConfig({ ...config, parentOccupation: e.target.value })} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Mobile Number" type="tel" value={config.phone} onChange={(e) => setConfig({ ...config, phone: e.target.value })} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Email Address" type="email" value={config.email} onChange={(e) => setConfig({ ...config, email: e.target.value })} fullWidth required />
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <button className="submitAdmission" type="submit">
                                        Submit Application 📝
                                    </button>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body2" sx={{ mt: 2, color: '#94a3b8', fontStyle: 'italic' }}>
                                        *Registration of the child does not guarantee admission. Final decision will be at the discretion of the Management.*
                                    </Typography>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                </Container>
            </div>
        </>
    )
}

export default Admission;